import Markdown from '../Markdown/Markdown';
import { RICH_TEXT_REHYPE_PLUGINS, RICH_TEXT_REMARK_PLUGINS } from './richText.constants';
import { getRichTextContentStyles } from './richText.styles';
import { prepareRichTextContent } from './richText.utils';

interface RichTextProps {
  children: string;
  variant?: 'body1' | 'body2';
  colorToken?: 'text.primary' | 'text.secondary';
  testId?: string;
}

const RichText = ({ children, variant, colorToken, testId }: RichTextProps) => (
  <Markdown
    variant={variant}
    colorToken={colorToken}
    rehypePlugins={RICH_TEXT_REHYPE_PLUGINS}
    remarkPlugins={RICH_TEXT_REMARK_PLUGINS}
    testId={testId}
    sx={getRichTextContentStyles}
  >
    {prepareRichTextContent(children)}
  </Markdown>
);

export default RichText;
